import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/kb")({
  component: KbLayout,
});

function KbLayout() {
  return <Outlet />;
}
